module.exports = __webpack_public_path__ + "img/partner-laendlekassa.107440cc.webp";